import styled from "styled-components";

export const Hero = styled.div`
  background: ${(p) => p.theme.tokens.gradients.header};
  padding: 28px 20px 26px;
  text-align: center;
  color: #fff;
  border-bottom-left-radius: ${(p) => p.theme.tokens.radii.xl}px;
  border-bottom-right-radius: ${(p) => p.theme.tokens.radii.xl}px;
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
`;

export const NavButton = styled.button`
  border: none;
  background: rgba(255, 255, 255, 0.16);
  color: #fff;
  font-weight: 800;
  font-size: 12.5px;
  font-family: ${(p) => p.theme.tokens.font.family};
  border-radius: 999px;
  padding: 7px 13px;
  cursor: pointer;
`;

export const CancelButton = styled(NavButton)`
  background: rgba(255, 255, 255, 0.12);
  color: #ffd8d0;
`;

export const IconBadge = styled.div`
  width: 62px;
  height: 62px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.16);
  margin: 6px auto 14px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const IconBadgeInner = styled.span`
  width: 44px;
  height: 44px;
  border-radius: 999px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.div`
  font-weight: 900;
  font-size: 20px;
  letter-spacing: -0.3px;
`;

export const OrderBadge = styled.div`
  display: inline-block;
  margin-top: 14px;
  background: rgba(255, 255, 255, 0.16);
  border-radius: 999px;
  padding: 7px 16px;
  font-weight: 800;
  font-size: 12.5px;
`;
